import { all, takeLatest, put, call } from 'redux-saga/effects';
import { ForexAPI } from 'client/api.config';
import { getStatusCode } from 'client/ErrorHandler';
import uploadActions from './actions';
import { UploadTypes } from './types';

const { request, success, failure } = uploadActions;

export function* upload({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  try {
    const { date, file } = payload;

    const formData = new FormData();
    formData.append('file', file, file.name);

    yield call(
      ForexAPI.post,
      `/v1/exchanges/report?referenceDate=${date}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );

    yield put(success());
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  yield all([takeLatest(UploadTypes.UploadRequest, upload)]);
}
